import validate from 'validate.js';
import validations from './validations.js';
import * as Dates from '../dates.js';
import { validateCreditCard } from '../creditCards.js';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';

/**
 * Validate the name field.
 * @param {string} name - The name to validate.
 * @returns {string|null} - Validation error message or null if valid.
 * @private
 */
function _validateName(name) {
  return name.split(' ').length < 2 ? i18n.t(tokens.labels.validations.firstAndLastName) : null;
}

/**
 * Validate input based on the field name and value.
 * @param {string} fieldName - The name of the field to validate.
 * @param {*} value - The value of the field.
 * @returns {string|null} - Validation error message or null if valid.
 */
const validateInput = (fieldName, value, locale = "en") => {
  // Handle special cases based on field name
  if (fieldName.toLowerCase().includes('effdate')) {
    return Dates.validateDate(value, false, false, true, locale);
  }
  if (fieldName.toLowerCase() === 'effectivedate') {
    return Dates.validateDate(value, false, false, false, locale);
  }
  if (['hiredate', 'studystartdate'].includes(fieldName.toLowerCase())) {
    return Dates.validateDate(value, false, false, false, locale);
  }
  if (fieldName.toLowerCase().includes('date')) {
    return Dates.validateDate(value, true, false, false, locale);
  }
  if (fieldName.toLowerCase().includes('credit')) {
    return validateCreditCard(value);
  }
  if (fieldName.toLowerCase() === 'name') {
    return _validateName(value);
  }

  // General validation using validate.js
  const formValues = {
    [fieldName]: value.toString()
  };
  const formFields = {
    [fieldName]: validations[fieldName]
  };
  const result = validate(formValues, formFields);
  return result ? result[fieldName][0] : null;
};
export default validateInput;